import ServiceDetail from '../components/services/ServiceDetail';

export default function Digitalizacion() {
    return <ServiceDetail id="digitalizacion" itemPrefix="di" count={6} heroTestid="digitalizacion-hero" gridTestid="digitalizacion-servicios" ctaTestid="digitalizacion-cta" />;
}
